import { defineWidgets, parse, parser, registry } from "blue-widgets";
import * as widgets from "./widgets";
import "./tools/rteTable";
import "./tools/splide";

defineWidgets({
  ...widgets,
});

parse();

window.blueWidgetReinit = (el) => {
  registry.destroyDescendants(el);
  parser.parse(el);
};
